
import './App.css';
import PlayerList from './PlayerList';

function App() {
  return (
    <div className="App">
      <PlayerList/>
    </div>
  );
}

export default App;
